import { createContext } from "react";
// eslint-disable-next-line
import { Updater } from "use-immer";

export const AssessmentScoreContext = createContext<{
  score: ClientAssessmentScore;
  setScore: Updater<ClientAssessmentScore>;
}>({
  score: {},
  setScore: () => {},
});
